<template>
  <!-- 舒适度 -->
  <div class="Others9Charts">
    <div
      :class="getStyle('title')"
      :style="{
        width: `${$w_Ratio(700 + getShowfontSizeBase(), $store)}px`,
        height: `${$h_Ratio(170 + getShowfontSizeBase(), $store)}px`,
      }"
    >
      <div class="flex-top-Comfort">
        <div
          class="top-Comfort"
          :style="{
            padding: `${$w_Ratio(2 + getShowfontSizeBase(), $store)}px 
          ${$w_Ratio(8 + getShowfontSizeBase(), $store)}px`,
            width: `${$w_Ratio(800 + getShowfontSizeBase(), $store)}px`,
          }"
        >
          <div
            class="title"
            :style="{
              fontSize: `${$w_Ratio(10 + getShowfontSizeBase(), $store)}px`,
            }"
          >
            <!-- 当前 承载 -->
            <div class="titleLeft">
              当前值
              <span :style="fontDataNuner()">
                {{ current }}
              </span>
            </div>
            <div class="titleRight">
              承载值
              <span class="PointValue">
                {{ bearing }}
              </span>
              人
            </div>
          </div>
        </div>
      </div>
      <div
        :style="{
          display: `flex`,
          alignItems: `center`,
          height: `${$h_Ratio(50 + getShowfontSizeBase(), $store)}px`,
        }"
      >
        <div class="line"></div>
        <div v-for="(item, index) in DataBar" :key="item" class="barStyle">
          <!-- 上 箭头 -->
          <div :class="ComfortTop[index]" :style="hideDisplay()"></div>
          <!-- 条 -->
          <div :class="ComfortTexe[index]">
            <span
              :style="{
                padding: `${$w_Ratio(4 + getShowfontSizeBase(), $store)}px`,
                fontSize: `${$w_Ratio(6 + getShowfontSizeBase(), $store)}px`,
              }"
              >{{ item }}</span
            >
          </div>
          <!-- 下 箭头 -->
          <div :class="ComfortBottom[index]" :style="hideDisplay()"></div>
        </div>
      </div>
      <!-- 值  -->
      <div class="loadBearing">
        <div
          v-for="item in DataNuner"
          :key="item"
          class="barStyleNuner"
          :style="{
            fontSize: `${$w_Ratio(10 + getShowfontSizeBase(), $store)}px`,
          }"
        >
          <div class="ComfortVal">
            <span
              :style="{
                marginLeft: `${$w_Ratio(0 + getShowfontSizeBase(), $store)}px`,
                fontSize: `${$w_Ratio(10 + getShowfontSizeBase(), $store)}px`,
              }"
            >
              {{ item }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getFilterValue } from '../../../utils/tool';
import { request } from '../../../common/request';
export default {
  name: 'Others9Charts',
  components: {},
  props: {
    Configuration: Object,
    ProjectInfo: Object,
  },
  data() {
    return {
      current: 1238,
      bearing: 64800,
      DataBar: ['舒适', '较舒适', '一般', '较拥挤', '拥挤'],
      ComfortTop: ['ComfortTop'],
      ComfortBottom: ['ComfortBottom'],
      ComfortTexe: ['ComfortTexe1', 'ComfortTexe2', 'ComfortTexe3', 'ComfortTexe4', 'ComfortTexe5'],
      DataNuner: ['0', '4000', '8000', '12000', '16000', '20000'],
    };
  },
  computed: {
    style() {
      return this.ProjectInfo.Style.componentName;
    },
  },
  watch: {
    ConfigureData: {
      deep: true,
      handler: function () {
        console.log('.....');
      },
    },
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          console.log('scale');
        } else if (this.Configuration.isMoving) {
          console.log('mov');
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  // created() {
  //   clearInterval(this.apiIntervalTaskID);
  //   clearInterval(this.staticIntervalTaskID);
  //   clearInterval(this.staticIntervalTaskID2);
  //   this.registerDebounceAndThrottle();
  // },
  mounted() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.registerDebounceAndThrottle();
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
      this.fontDataNuner();
      this.hideDisplay();
    });
    this.getApiDataResByFilterAndResponseQuery();
    // 默认取api参数
    let that = this;
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    let params = ChartsData?.apiData?.apiPostParams || '{}';
    this.params = eval('(' + params + ')');
    this.paramsCopy = eval('(' + params + ')');
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.unRegisterDebounceAndThrottle();
  },
  methods: {
    getStyle(e = '') {
      let style = {};
      let bool = e == 'title';
      switch (this.style) {
        case 'V1Style':
          style = {};
          if (bool) style['V1StyleTitle'] = true;
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style = {};
          if (bool) style['V2StyleTitle'] = true;
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style = {};
          if (bool) style['V3StyleTitle'] = true;
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style = {};
          if (bool) style['V4StyleTitle'] = true;
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style = {};
          if (bool) style['V5StyleTitle'] = true;
          style['V5Style'] = true;
          break;
        case 'V6Style':
          style = {};
          if (bool) style['V6StyleTitle'] = true;
          style['V6Style'] = true;
          break;
        case 'V7Style':
          style = {};
          if (bool) style['V7StyleTitle'] = true;
          style['V7Style'] = true;
          break;
        case 'V8Style':
          if (bool) style['V8StyleTitle'] = true;
          style['V8Style'] = true;
          break;
        case 'V9Style':
          if (bool) style['V9StyleTitle'] = true;
          style['V9Style'] = true;
          break;
        case 'V10Style':
          if (bool) style['V10StyleTitle'] = true;
          style['V10Style'] = true;
          break;
        case 'V11Style':
          if (bool) style['V11StyleTitle'] = true;
          style['V11Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    getFilterValue(e) {
      return getFilterValue(e);
    },
    fontDataNuner() {
      if (this.current != 0 && this.current <= this.DataNuner[1]) {
        return {
          color: '#72bb37',
          fontSize: `${this.$w_Ratio(8 + this.getShowfontSizeBase(), this.$store)}px`,
        };
      } else if (this.current <= this.DataNuner[2]) {
        return {
          color: '#85cb17',
          fontSize: `${this.$w_Ratio(8 + this.getShowfontSizeBase(), this.$store)}px`,
        };
      } else if (this.current <= this.DataNuner[3]) {
        return {
          color: '#f3c802',
          fontSize: `${this.$w_Ratio(8 + this.getShowfontSizeBase(), this.$store)}px`,
        };
      } else if (this.current <= this.DataNuner[4]) {
        return {
          color: '#fd8b00',
          fontSize: `${this.$w_Ratio(8 + this.getShowfontSizeBase(), this.$store)}px`,
        };
      } else if (this.current <= this.DataNuner[5]) {
        return {
          color: '#f64001',
          fontSize: `${this.$w_Ratio(8 + this.getShowfontSizeBase(), this.$store)}px`,
        };
      }
    },
    hideDisplay() {
      if (this.current > -1 && this.current <= this.DataNuner[1]) {
        return { left: `0` };
      } else if (this.current <= this.DataNuner[2]) {
        return { left: `100%` };
      } else if (this.current <= this.DataNuner[3]) {
        return { left: `200%` };
      } else if (this.current <= this.DataNuner[4]) {
        return { left: `300%` };
      } else if (this.current > this.DataNuner[5]) {
        return { left: `400%` };
      }
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      let grid = {};
      let source = [];
      let seriesList = [];
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }
      console.log(source);
      console.log(seriesList);
      console.log(fontStyle);
      console.log(grid);

      this.current = source[0].y;
      this.bearing = source[1].y;

      // 处理进度条下数据
      let bear = source[1].y;

      let num = 6;
      let newArr = [0];
      const n = parseInt(bear / (num - 1));
      let v = 0;
      for (let i = 0; i < num - 1; i++) {
        if (newArr.length === num) {
          newArr.push(bear);
          break;
        }
        newArr.push(n + v);
        v = n + v;
      }
      this.DataNuner = newArr;
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          let data = this.$_.cloneDeep(ChartsData.staticData);

          this.setEchartsOptions(data);
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);

        this.staticIntervalTaskID2 = setInterval(() => {
          func();
        }, (chartsAnimation?.staticRefreshIntervalTime - 2 <= 0 ? 1 : chartsAnimation?.staticRefreshIntervalTime - 2) * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          console.log(res, 'ConfigureData apiData');
          this.setEchartsOptions(res);
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        console.log(res, 'ConfigureData apiData');
        this.setEchartsOptions(res);
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   params: this.params,
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   data: this.params,
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // console.log('getApiDataResByResponseQuery');
            console.log(res, 'getApiDataResByResponseQuery');
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          console.log(filter_text, 'filter_text');
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              // console.log(res, 'ChartsData filter_text');
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            console.log(res, 'res getApiDataResByResponseQuery');
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getHeaderInfopStyle(fs = 14, pt = 0) {
      return {
        paddingTop: this.$h_Ratio(pt, this.$store) + 'px',
        fontSize: this.$w_Ratio(fs, this.$store) + 'px',
      };
    },
    getWidthStyle(fs = 14) {
      return {
        fontSize: this.$w_Ratio(fs + this.getShowfontSizeBase(), this.$store) + 'px',
      };
    },
    getStyleContainerStyle() {
      return {
        height: this.$h_Ratio(this.style.height, this.$store) + 'px',
        backgroundColor: this.style.backgroundColor,
      };
    },
    handleClick(e) {
      e.stopPropagation();
      this.$store.commit('set_CurrentConfigration', this.Configuration);
    },
  },
  computed: {
    cityNameCopy() {
      return this.Configuration.propertyData.cityName.value;
    },
  },
  Configuration: {
    componentTitle: '舒适度',
    componentName: 'Others9Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others9Charts.png',
    id: '',
    style: {
      width: 380,
      height: 124,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      menuStyle: {
        value: {
          height: 85,
          width: 700,
        },
      },
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },

      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果        
                let seriesList = []

            let seriesListKey = 'city'
                let seriesListChildrenKey = 'casts'

                 data.forEach((item) => {
               seriesList.push(item[seriesListKey])
                 })
                dataSet.seriesList = seriesList
                   dataSet.source = []
              data.forEach((item) => {
              item[seriesListChildrenKey].forEach(item2 => {
                 dataSet.source.push({
                  s: item[seriesListKey],
                x: item2.date,
                 y: item2.daytemp
               })
                })
             })
            `,
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['当前值', '承载值'],
            source: [
              {
                s: '当前值',
                y: '1238',
                x: '人',
              },
              {
                s: '承载值',
                y: '20000',
                x: '人',
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '0%',
          top: '0%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.Others9Charts {
  width: 100%;
  height: 100%;
  padding: 10px 14px;

  .line {
    z-index: 1;
    width: 82%;
    left: 50%;
    margin-top: -1%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -ms-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    height: 3%;
    background: linear-gradient(
      to right,
      #12f88c,
      #4bf958,
      #94fa17,
      #e8f90b,
      #eef80a,
      #f2f809,
      #f4f708,
      #f6f706,
      #fbf605,
      #ffef03,
      #ffeb01,
      #fee600,
      #feab00,
      #fe9800,
      #fd6801
    );
    position: absolute;
  }
  .ComfortTexe1 {
    background: linear-gradient(to right, #09d951, #14da45, #28de34, #95df06);
    border-radius: 14px 0 0 14px;
    display: flex;
    margin: 4px 0;
    align-items: center;
    justify-content: center;
    span {
      z-index: 999;
      color: #085b22;
      font-family: fantasy;
      font-weight: 700;
    }
  }
  .ComfortTexe2 {
    background: linear-gradient(to right, #95df06, #9cde06, #bcd807, #cad805);
    display: flex;
    align-items: center;
    margin: 4px -6px;
    justify-content: center;
    span {
      z-index: 999;
      color: #3f5a05;
      font-family: fantasy;
      font-weight: 700;
    }
  }
  .ComfortTexe3 {
    background: linear-gradient(to right, #cad805, #dbd503, #dbd503, #f4c504);
    display: flex;
    margin: 4px 0;
    align-items: center;
    justify-content: center;
    span {
      z-index: 999;
      color: #595603;
      font-family: fantasy;
      font-weight: 700;
    }
  }
  .ComfortTexe4 {
    background: linear-gradient(to right, #f4c504, #fe9100, #fe9100, #fd7601);
    display: flex;
    align-items: center;
    margin: 4px -6px;
    justify-content: center;
    span {
      z-index: 999;
      font-family: fantasy;
      font-weight: 700;
      color: #724403;
    }
  }
  .ComfortTexe5 {
    background: linear-gradient(to right, #fd7601, #f85700, #f64001, #f63900);
    border-radius: 0 14px 14px 0;
    display: flex;
    align-items: center;
    margin: 4px 0;
    justify-content: center;
    span {
      z-index: 999;
      color: #780c02;
      font-family: fantasy;
      font-weight: 700;
    }
  }
  .ComfortTop {
    height: 0;
    width: 0;
    margin: 0 auto;
    position: relative;
    border-top: 8px solid #f7f707;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
  }
  .ComfortBottom {
    height: 0;
    width: 0;
    margin: 0 auto;
    position: relative;
    border-bottom: 8px solid #f7f707;
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
  }
  .barStyle {
    width: 100%;
    /* height: 100%; */
  }
  .barStyleNuner {
    width: 100%;
    height: 100%;
    .ComfortVal {
      span {
        font-family: PingFang SC;
        color: #b8bcc4;
      }
    }
  }
  .barStyleNuner:last-child {
    position: relative;
    left: 6%;
  }
  .loadBearing {
    display: flex;
    justify-content: space-between;
  }

  .flex-top-Comfort {
    display: flex;
    justify-content: space-between;
  }
  .PointValue {
    position: relative;
    /* left: 6px; */
    color: #f6e803;
    font-weight: bold;
  }
  .title {
    display: flex;
    /* justify-content: space-between; */
    div {
      color: #fff;
      font-weight: 600;
      width: 50%;
    }
    .titleRight {
      text-align: right;
    }
    .titleLeft {
      text-align: left;
    }
    &::after {
      display: none;
    }
    .dot {
      border-radius: 50%;
      background: #a9a9a9;
    }
  }
}
.V3Style {
  height: 100%;
}
.value {
  background: linear-gradient(to bottom, #fff, #fffb47);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  font-weight: bold;
}
@media (max-width: 1400px) {
  .top-Comfort {
    margin-bottom: 10px !important;
  }
}
</style>
